/**
* PURPOSE: Helpers para normalizar y mostrar hashtags de usuarios.
* RESPONSIBILITIES: Convierte entradas flexibles a formato persistido #tag#tag y parsea chips visuales.
* COLLABORATORS: src/sections/UserSection.jsx, src/admin/CreateUser/Modal/ModalCreateUser/ModalCreateUser.jsx, src/admin/CreateUser/Modal/ModalEditUser/ModalEditUser.jsx
* ROUTE: src/utils/userHashtag.js
*/
export function normalizeUserHashtagInput(value) {
  const raw = String(value || "").trim().toLowerCase();
  if (!raw) return "";

  const tokens = raw
    .replace(/,/g, " ")
    .replace(/#/g, " #")
    .split(/\s+/)
    .map((token) => token.trim())
    .filter(Boolean)
    .map((token) => token.replace(/^#+/, ""))
    .map((token) => token.replace(/[^a-z0-9_\-]/gi, ""))
    .filter(Boolean);

  return [...new Set(tokens)].map((token) => `#${token}`).join("");
}

export function parseUserHashtags(value) {
  const normalized = normalizeUserHashtagInput(value);
  if (!normalized) return [];

  return normalized
    .split("#")
    .map((token) => token.trim())
    .filter(Boolean)
    .map((token) => `#${token}`);
}
